// Faz 3 / PM-01 — "Ekip Hedefleri" sayfasının görünürlük kuralları.
//
// SESSİZ ÖLÜM NOKTASI: bu sayfa amirin hedef onayı / dönem sonu puanlaması /
// revizyon kararı verdiği TEK web yüzeyidir ve aksiyon kolonları eskiden
// `canWrite('PM')` ile açılıyordu. Backend'de karar uçlarının kapısı ilişkiye
// devredildi (PeriodGoalDataAccess.CheckManagerDecisionScopeAsync: doğrudan
// rapor ∪ aktif vekâlet ∪ İK), ama bu satır değişmeseydi düzeltme hiçbir
// kullanıcıya ULAŞMAZDI: PM.Write'ı olmayan amir tabloyu görür, tek bir aksiyon
// butonu GÖRMEZDİ.
//
// Kurallar SAF fonksiyonlara çıkarıldı (fillFeedbackGates.js deseni) — sayfanın
// içinde satır olarak kalsalardı mutasyonla ölçülemezlerdi.

// Yönetici aksiyonları: "PM yazma izni VARSA" ya da "astı VARSA".
// Yanlış pozitifte kullanıcı backend'den 403 alır (kapı orada); yanlış
// negatifte amir işini HİÇ yapamaz — ikincisi çok daha pahalıdır.
export function canDecideOnTeamGoals({ canWritePm, hasSubordinates }) {
  return Boolean(canWritePm || hasSubordinates);
}

// İK kuyrukları (hr-decision / revisions hr-decision) BİLEREK DAR kalır:
// backend bu kararları İK'yla sınırlıyor (CheckHrScopeAsync → HrActorRules), yani
// `hasSubordinates` burada YETMEZ — aksi halde amire 403'lenecek butonlar
// gösterilirdi. İK rolü ayrımı (2026-10-28): İK = AuthContext.isHr (İK Rolü sahibi;
// kiracı İK rolü kullanmıyorsa Şirket Yöneticisi) — enterpriseAdmin DEĞİL.
export function canSeeHrQueues({ canWritePm, isHr }) {
  return Boolean(canWritePm && isHr);
}
